<!-- eslint-disable prettier/prettier -->
<template>
  <div class="wrapper">
    <nav>
      <button
        class="nav-btn nav-toggler"
        v-bind:class="[sidebarIsActive ? '' : 'active']"
        @click="toggleClass()"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
      <div v-if="permission1" class="logo-wrapper">
        <router-link to="/consulta">
          <img
            class="logo"
            :src="require(`../assets/images/${logo}`)"
            alt="Logo"
          />
        </router-link>
      </div>
      <div v-if="!permission1" class="logo-wrapper">
        <router-link to="/loading">
          <img
            class="logo"
            :src="require(`../assets/images/${logo}`)"
            alt="Logo"
          />
        </router-link>
      </div>
      <div class="nav-items">
        <div
          class="product-navigation"
          v-if="
            $route.path.includes('cliente') || $route.path.includes('producto')
          "
        >
          <div
            :id="$route.params.productName"
            class="active-product"
            :class="
              `product-${($route.params.productName || '.').split('.')[0]}`
            "
            v-if="$route.path.includes('producto')"
          >
            <span
              class="icon-wrapper"
              v-if="$route.params.productName !== 'GuiadelaSaludPR.com'"
            >
              <img
                :src="
                  require(`../assets/images/products/${$route.params.productName}.svg`)
                "
              />
            </span>

            <span
              class="icon-wrapper"
              v-if="$route.params.productName === 'GuiadelaSaludPR.com'"
            >
              <img
                class="img2"
                :src="
                  require(`../assets/images/products/${$route.params.productName}.svg`)
                "
              />
            </span>

            <p class="productName">{{ change($route.params.productName) }}</p>
          </div>

          <div class="products">
            <ul class="nav-products">
              <!--  -->
              <div
                class="container"
                v-for="product of products"
                :key="product.productId"
              >
                <li
                  :class="`product-item product-${product.class}`"
                  @click="selectProduct(product)"
                >
                  <router-link
                    :class="`${!product.isActived ? 'inactive' : ''}`"
                    :to="
                      `/producto/${product.class}/${
                        product.productId
                      }/subscribers/${product.subscriberId}/businessUnit/${
                        product.businessUnitId
                      }/${(product.name || 'logo').replace(
                        / /g,
                        ''
                      )}?customerId=${getCustomerId(product)}`
                    "
                  >
                    <span
                      :class="`icon-wrapper`"
                      v-if="product.class !== 'SLOLPR'"
                    >
                      <img
                        :src="
                          require(`../assets/images/products/${product.class}.svg`) ||
                            product.logo
                        "
                      />
                    </span>

                    <span
                      class="icon-wrapper"
                      v-if="product.class === 'SLOLPR'"
                    >
                      <img
                        class="img2"
                        :src="
                          require(`../assets/images/products/${product.class}.svg`) ||
                            product.logo
                        "
                      />
                    </span>
                  </router-link>
                </li>
              </div>

              <!-- <li class="product-item product-places-to-go">
                <router-link to="/producto/places-to-go">
                  <span class="icon-wrapper">
                    <img src="../assets/images/products/places-to-go.svg" />
                  </span>
                </router-link>
              </li>
              <li class="product-item product-salud-online">
                <router-link to="/producto/salud-online">
                  <span class="icon-wrapper">
                    <img src="../assets/images/products/salud-online.svg" />
                  </span>
                </router-link>
              </li>-->
            </ul>
          </div>
        </div>
        <div class="dashboard-actions">
          <el-date-picker
            v-model="value1"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="a"
            start-placeholder="Inicio"
            end-placeholder="Final"
            :picker-options="pickerOptions"
            @change="filterByDate"
          ></el-date-picker>
          <el-dropdown>
            <span class="el-dropdown-link">
              <span>{{ userName }}</span>
              <font-awesome-icon icon="user" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <router-link to="/manage/">
                  Administrar cuenta
                </router-link>
              </el-dropdown-item>
              <el-dropdown-item>
                <router-link to v-on:click.native="logout"
                  >Cerrar sesión</router-link
                >
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </nav>
    <div class="content-wrapper">
      <sidebar v-bind:class="[sidebarIsActive ? '' : 'active']"></sidebar>
      <div
        class="content"
        v-bind:class="[sidebarIsActive ? '' : 'sidebar-open']"
      >
        <transition name="fade" mode="out-in">
          <router-view id="content" ref="content" />
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import Sidebar from "@/components/Sidebar.vue";
import { mapGetters } from "vuex";
import { BUSINESS_UNIT_ID, CLASS_CODE } from "../constants";
export default {
  name: "dashboard",
  components: {
    Sidebar
  },
  props: ["routeClass"],
  data() {
    return {
      logo: localStorage.getItem("logoURL"),
      productName: "P",
      userName: "",
      selectedProduct: {},
      permission1: false,
      permission2: false,
      // sidebarIsActive: true,
      pickerOptions: {
        shortcuts: [
          {
            text: "Últimos 2 año",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 730);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Ultimo año",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Personalizado",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "ultimo mes",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "ultima semana",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      value1: [],
      value2: ""
    };
  },
  created() {
    // const context = this;
    // this.change(context);
    // .

    const roll = localStorage.getItem("roll");
    if (roll === "Administrator") {
      this.permission1 = true;
      this.permission2 = true;
    }
    if (roll === "Consulting") {
      this.permission1 = true;
      this.permission2 = false;
    }
    if (roll === "Customer") {
      this.permission1 = false;
      this.permission2 = false;
    }

    const businessUnitId = localStorage.getItem("businessUnitId");

    this.userName = localStorage.getItem("userName");
    this.productName = this.$route.params.productName;
    if (businessUnitId === BUSINESS_UNIT_ID.RD) {
      this.logo = "logo.svg";
    } else if (businessUnitId === BUSINESS_UNIT_ID.PR) {
      this.logo = "logo-axesa.svg";
    } else if (businessUnitId === BUSINESS_UNIT_ID.IP) {
      this.logo = "logo-ip.svg";
    }
    const today = new Date();

    function formatDate(D) {
      const day = ("0" + D.getDate()).slice(-2);
      const month = ("0" + (D.getMonth() + 1)).slice(-2);
      const year = D.getFullYear();

      const fullDate = `${year},${month},${day}`;
      const fullDate2 = `${year}-${month}-${day}`;
      return { fullDate, fullDate2 };
    }

    const dateTodayFormat = formatDate(today);
    today.setMonth(today.getMonth() - 12);
    const lastYear = formatDate(today);

    this.value1 = [lastYear.fullDate, dateTodayFormat.fullDate];
    this.$store.commit("FillDate1", dateTodayFormat.fullDate2);
    this.$store.commit("FillDate2", lastYear.fullDate2);
  },
  methods: {
    change(ProductName) {
      if (ProductName === "AnunciosdebúsquedaenGoogle") {
        return "Anuncios de búsqueda en Google";
      } else if (ProductName === "Paginasamarillas.com.do") {
        return "Paginasamarillas.com.do";
      } else if (ProductName === "SocialMediaPost") {
        return "Social Media Post";
      } else if (ProductName === "AnunciosdeMáximoRendimiento") {
        return "Anuncios de Máximo Rendimiento";
      } else if (ProductName === "AnunciosdeYoutube") {
        return "Anuncios de Youtube";
      } else if (ProductName === "AnunciosdeRedesSociales") {
        return "Anuncios de Redes Sociales";
      } else if (ProductName === "AnunciosdeDisplayenGoogle") {
        return "Anuncios de Display en Google";
      } else if (ProductName === "CampañasdeGeneracióndeDemanda") {
        return "Campañas de generación de demanda";
      } else if (ProductName === "CampañasLocales") {
        return "Campañas Locales";
      } else if (ProductName === "SuWebsite") {
        return "Su Website";
      } else if (ProductName === "GoogleMyBusiness") {
        return "Google My Business";
      } else if (ProductName === "SpotifyAds") {
        return "Spotify Ads";
      } else if (ProductName === "LinkedInAds") {
        return "Linkedin Ads";
      } else if (ProductName === "GoogleCampaigns") {
        return "Google Campaigns";
      } else if (ProductName === "Leads") {
        return "Leads";
      } else if (ProductName === "Tiktok") {
        return "Tiktok";
      } else {
        return ProductName;
      }
    },
    getCustomerId: function(product) {
      switch (product.class) {
        case CLASS_CODE.GOOGLE_MY_BUSINESS:
          return product.googleMyBusinessProfileId;
        case CLASS_CODE.SPOTIFY:
          return product.spotifyAccountId;
        case CLASS_CODE.LINKEDIN:
          return product.linkedinAccountId;
        case CLASS_CODE.INFOPAGINAS:
          return product.infopaginasClientId;
        case CLASS_CODE.TIKTOK:
          return product.tiktokAccountId;
        default:
          return product.googleAccountId;
      }
    },
    filterByDate: function(selectedDate) {
      let fromDate = String(selectedDate[0]);
      let toDate = String(selectedDate[1]);

      function formatDate(D) {
        const day = ("0" + D.getDate()).slice(-2);
        const month = ("0" + (D.getMonth() + 1)).slice(-2);
        const year = D.getFullYear();

        const fullDate = `${year}-${month}-${day}`;

        return fullDate;
      }

      const fromDateF = formatDate(new Date(`${fromDate}`));
      const toDateF = formatDate(new Date(`${toDate}`));
      this.$store.commit("FillDate1", toDateF);
      this.$store.commit("FillDate2", fromDateF);

      let timerInterval;
      Swal.fire({
        title: "Cargando tus metricas!",
        html: `Desde ${fromDateF} hasta ${toDateF}`,
        timer: 5000,
        timerProgressBar: true,
        onBeforeOpen: () => {
          Swal.showLoading();
          timerInterval = setInterval(() => {
            // Swal.getContent().querySelector(
            //   "b"
            // ).textContent = Swal.getTimerLeft();
          }, 100);
        },
        onClose: () => {
          clearInterval(timerInterval);
        }
      }).then(result => {
        if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.timer
        ) {
          console.log("I was closed by the timer"); // eslint-disable-line
        }
      });
    },

    toggleClass: function() {
      if (this.sidebarIsActive) {
        // this.sidebarIsActive = false;
        this.$store.commit("FillsidebarIsActive", false);
      } else {
        // this.sidebarIsActive = true;
        this.$store.commit("FillsidebarIsActive", true);
      }
    },
    selectProduct: function(product) {
      this.selectedProduct = product;
    },
    logout() {
      localStorage.removeItem("user-token");
      localStorage.removeItem("token-expiration");
      this.$router.push({ name: "login" });
    }
  },
  computed: {
    ...mapGetters(["products", "sidebarIsActive"])
  }
};
</script>
<style lang="scss" scoped>
.productName {
  white-space: nowrap;
  min-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}

.el-dropdown {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  .el-dropdown-link {
    span {
      display: none;
    }
  }
}

.bg-inactive {
  background: #e6e6e6 !important;
  .icon-wrapper {
    background-color: #e6e6e6 !important;
  }
  .productName {
    color: #333333;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.wrapper {
  height: 100%;
}

.content-wrapper {
  height: 100%;
  overflow: hidden;
  position: relative;
}

.content {
  background-color: $bkg-color;
  height: 100%;
  transition: $default-transition;
  position: relative;
  padding: 20px;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  position: absolute;
  margin-top: 60px;
  &.sidebar-open {
    left: 85%;
    // pointer-events: none;
  }
}

.nav-products .product-item a.inactive {
  .icon-wrapper {
    background: #e6e6e6 !important;
    img {
      opacity: 0.5;
      -webkit-filter: grayscale(100%);
      filter: grayscale(100%);
    }
  }
}

@include respond-above(ss) {
  .sidebar-wrapper {
    width: 50%;
  }
  .content {
    &.sidebar-open {
      left: 50%;
    }
  }
}

@include respond-above(ss) {
  .sidebar-wrapper {
    width: 40%;
  }
  .content {
    &.sidebar-open {
      left: 40%;
    }
  }
  .el-dropdown {
    font-size: 12px;
    width: auto;
    .el-dropdown-link {
      display: flex;
      span {
        display: block;
        margin-right: 5px;
      }
      .fa-user {
        margin-top: 3px;
      }
    }
  }
}

@include respond-above(md) {
  .content-wrapper {
    .sidebar-wrapper,
    .sidebar-wrapper.active {
      width: 280px;
      left: 0;
    }
    .content,
    .content.sidebar-open {
      position: relative;
      padding: 50px;
      width: auto;
      left: 0;
      margin-top: 60px;
      margin-left: 280px;
      border-top-left-radius: 25px;
    }
  }
}
</style>
